import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import { Subtitle, UpperTitle } from "../StyledComponents";

const Input = ({ value, onChange }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
      }}
    >
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: "250px",
          textAlign: "center",
          fontSize: "1.25rem",
          fontWeight: "bold",
          border: "none",
          borderBottom: "1px solid #ccc",
          backgroundColor: "transparent",
          padding: "2px 4px",
          outline: "none",
        }}
      />
    </div>
  );
};

const InfoSimpleCard = ({ item, setValue, editable }) => {
  const {
    label,
    value,
  } = item || {};

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "12px 0"
      }}
    >
      <Row noGutters style={{ marginBottom: "6px" }}>
        {editable ? (
          <Input
            value={value}
            onChange={setValue}
          />
        ) : (
          <UpperTitle>{value}</UpperTitle>
        )}
      </Row>
      <Row noGutters>
        <Subtitle>{label}</Subtitle>
      </Row>
    </div>
  );
};

export default InfoSimpleCard;
